import React from 'react';
import { Card } from '@naf-simba/sections-cards';
import { Grid, GridCol } from '@naf/grid';
import { useLocation } from 'react-router';
import { getLabelVariant } from '@lib/getLabelVariant';
import { BenefitsType } from '../../../../types/benefitsType';
import defaultBenefitImage from '../../../assets/images/defaultLocalBenefit.svg?url';
import { StyledLink } from '../styled-link/StyledLink';
import { formatDate } from '../../utils/Dates';

interface Props {
  benefitItems: Record<string, BenefitsType> | BenefitsType[];
  size?: 'standard' | 'small';
  className?: string;
}
const BenefitsGrid = ({ benefitItems, size = 'small', className }: Props) => {
  const benefits = !(benefitItems instanceof Array) ? Object.values(benefitItems) : benefitItems;
  const columns = size === 'small' ? '4' : '6';
  const location = useLocation();

  return (
    <Grid>
      {benefits.map(
        ({
          image,
          name,
          title,
          slug,
          isNewBenefit,
          campaignDetails,
          id,
          isLocalContent,
          localBenefitImage,
          ingress,
        }) => {
          const localImage =
            localBenefitImage?.source === 'NafIllustration' ? defaultBenefitImage : localBenefitImage?.url || '';
          const hasActiveCampaign = campaignDetails?.endDate && new Date(campaignDetails.endDate) > new Date();
          const formattedDate = campaignDetails?.endDate ? formatDate(campaignDetails.endDate) : null;

          return (
            <GridCol s="12" m="12" l={columns} xl={columns} className={className} key={id || slug || name}>
              <StyledLink
                $hasCardGrid
                to={
                  isLocalContent ? `${location.pathname}/fordeler/${slug}` : `/medlemskap/medlemsfordeler/${slug || id}`
                }
              >
                <Card
                  title={name || title || ''}
                  description={ingress}
                  media={{
                    src: isLocalContent ? localImage : image?.srcSet?.jpgLarge || '',
                    alt: isLocalContent ? localBenefitImage?.caption || '' : image?.altText || '',
                  }}
                  label={
                    isNewBenefit || hasActiveCampaign
                      ? {
                          text: isNewBenefit ? 'Ny fordel' : `Varer til ${formattedDate}`,
                          position: 'top-right',
                          ...getLabelVariant(isNewBenefit ? 'signature' : 'moss'),
                        }
                      : undefined
                  }
                />
              </StyledLink>
            </GridCol>
          );
        },
      )}
    </Grid>
  );
};

export default BenefitsGrid;
